/**
 * `useIsMobile` — true below the workspace's drawer breakpoint.
 *
 * Drives the `Sidebar` primitive's desktop-rail vs. mobile-sheet switch. The
 * breakpoint is `1024px` (Tailwind `lg`) to match the workspace chrome, which
 * has always shown the full sidebar at `lg+` and an off-canvas drawer below.
 */
import * as React from "react";

const MOBILE_BREAKPOINT = 1024;

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    mql.addEventListener("change", onChange);
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return !!isMobile;
}
